import chatbot from './chatbot'
import tools from './tools'
import cloudflare from './cloudflare'

//Export to use in Components
// api [type] [verb]
// EX: api.directMessage.reply
export default {
    chatbot: chatbot,
    tools: tools,
    cloudflare: cloudflare
}